<template lang="pug">
  v-col.text-center
    input-phone(v-model="phoneNumber")
    v-btn(
      color="primary"
      :loading="loading"
      @click="addPhoneNumber"
      :disabled="!phoneNumber") Ajouter
</template>

<script>
import { reactive, toRefs } from '@vue/composition-api'
import data from '@iez/lib/data/'
import InputPhone from '@iez/components/inputs/phone/'

export default {
  components: {
    InputPhone
  },

  setup () {
    const state = reactive({
      phoneNumber: '',
      loading: false
    })

    const addPhoneNumber = async () => {
      state.loading = true
      await data.set({
        root: 'associations',
        fields: ['id', 'phoneNumber'],
        items: [{
          phoneNumber: state.phoneNumber
        }]
      })
      state.loading = false
      state.phoneNumber = ''
    }

    return {
      ...toRefs(state),
      addPhoneNumber
    }
  }
}
</script>